import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NewPracticeOrJoin, JoinExistingPractice } from '../../components/signup';
import { PatientFallback } from '../../components/signup/PatientFallback';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';
import LegacySignupPage from '../LegacySignupPage';
import { restartAnalyticsCapture, stopAnalyticsCapture } from 'shared-utils/analytics';

const SignupInitialContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [fallbackScreenToShow, setFallbackScreenToShow] = useState<'join_existing' | 'patient' | null>(null);
  const [showLegacySignup, setShowLegacySignup] = useState(false);
  const { data: featureFlags, isLoading: isLoadingFeatureFlags } = useFeatureFlags();

  useEffect(() => {
    stopAnalyticsCapture();
  }, []);

  if (fallbackScreenToShow === 'join_existing') {
    return <JoinExistingPractice />;
  } else if (fallbackScreenToShow === 'patient') {
    return <PatientFallback />;
  } else if (showLegacySignup) {
    return <LegacySignupPage />;
  }

  if (isLoadingFeatureFlags) {
    return <LoadingSpinner />;
  }

  const handleCreateNew = () => {
    restartAnalyticsCapture();
    if (featureFlags?.providerSplitSignup) {
      // pass the url search params to the start page so we can track the source of the signup
      navigate({ pathname: '/signup/start', search: location.search });
    } else {
      setShowLegacySignup(true);
    }
  };

  const handleJoinExisting = () => {
    restartAnalyticsCapture();
    setFallbackScreenToShow('join_existing');
  };

  return (
    <NewPracticeOrJoin
      onJoinExisting={handleJoinExisting}
      onCreateNew={handleCreateNew}
      onClickPatientOption={() => setFallbackScreenToShow('patient')}
    />
  );
};

export default SignupInitialContent;
